import { FeatureAttribute } from "../components/Attributes/FeatureAttributeField";

export const tooltipNameFromAttributes = (name: string, attributes: FeatureAttribute[]) => {
  const attribute = attributes.find(item => item.name === name);

  return attribute?.alias || name;
};
